import { useEffect, useRef, useState } from "react";
import { SEV_LABEL, SEV_POS, METER_LABEL, type Severity } from "../profiles";

export function SeverityMeter({ severity }: { severity: Severity }) {
  const [left, setLeft] = useState("8%"); // default; animates to SEV_POS on mount
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  useEffect(() => {
    timer.current = setTimeout(() => setLeft(SEV_POS[severity]), 340);
    return () => clearTimeout(timer.current);
  }, [severity]);
  return (
    <div className="meter-wrap reveal">
      <div className="meter-top">
        <span className="meter-label">{METER_LABEL}</span>
        <span className="meter-level">{SEV_LABEL[severity]}</span>
      </div>
      <div className="meter-track">
        <div className="meter-pin" style={{ left }} />
      </div>
    </div>
  );
}
